import React, { useState, useEffect, useRef } from 'react'

import { user, socketConnected, socket } from '../../../utils/nakama'
import { playSound, handleClickSound } from '../../game/scenes/classes/PlaySound'

import Message from './Message.jsx'

import '../../../assets/styles/chat-room.css'
import pfpRingPanel from '../images/pfp_ring_panel.svg'
import eventsCenter, { PHASER_EVENTS } from '../../../utils/phaserEvents.js'

function ChatRoom(props) {
  const { onlineUsers, onlineUsersRef, setOnlineUsers, client, session, userAvatars, player2Data, joinMatch, friendRequestPending, boneReady, leaveChat, showMatchAnnouncement } = props;

  const [userMessage, setUserMessage] = useState("");
  const [chatChannel, setChatChannel] = useState(null);
  const [userJoinMsg, setUserJoinMsg] = useState(false);
  const roomName = "BonezLobby";
  const [messages, _setMessages] = useState([]);
  const messagesRef = useRef(messages);
  const [messageCount, setMessageCount] = useState(0);
  const messagesLoadedRef = useRef(false);
  const [showNotify, setShowNotify] = useState("hidden");

  const setupInternalPhaserEventListeners = () => {
    //Not sure why, but the listener is being added multiple times. This prevents that
    if(eventsCenter.listeners(PHASER_EVENTS.BONE_RECEIVED).length < 1){
        eventsCenter.on(PHASER_EVENTS.BONE_RECEIVED, (payload)=> {
            setShowNotify("visible");
        });
    }
  }

  const setMessagesLoaded = (update) => {
    messagesLoadedRef.current = update;
  }
  const setMessages = (update) => {
    if (typeof update === 'function') {
      _setMessages(prev => {
        const next = update(prev);
        messagesRef.current = next;
        return next;
      });
    } else {
      const next = Array.isArray(update) ? [...update] : update;
      messagesRef.current = next;
      _setMessages(next);
    }
  }
  

  useEffect(() => {
    const _joinChat = async (room) => {
      // console.log(messagesLoadedRef);
      if (!messagesLoadedRef.current && props.joinChat) {
        let channel = await socket.joinChat(room, 1, true, false);
        if (channel.presences) {
          setOnlineUsers(channel.presences);
        }

        //Loading Previous Messages
        var msgs = await client.listChannelMessages(session, channel.id, 30, false);
        setMessagesLoaded(true);

        // listChannelMessages returns newest-first when forward=false; reverse so oldest-first
        const history = [];
        for (var i = msgs.messages.length - 1; i > -1; i--) {
          if (messagesRef.current.indexOf(msgs.messages[i]) === -1) {
            history.push(msgs.messages[i]);
          } else {
            break;
          }
        }

        let newUserJoined = {
          username: "System",
          content: {
            message: `${session.username} has joined the chat`
          },
          user_id: session.user_id,
        }
        //Welcome message from AI and instructions on how to use the AI helper
        let welcomeMessage = {
          username: "DeckSter",
          content: {
            message: "Hi, I am here to help you with any questions you have about the game. If you need help at any time, type !help"
          },
        }
        setMessages(prev => [...prev, ...history, welcomeMessage, newUserJoined]);
        setMessageCount(prev => prev + history.length + 2);
        setChatChannel(channel)
        // // Setup initial online user list. 
        // // * Should only be done when the onlineUsers array is empty or multiple pushes will occur with socket event resulting in duplicate users
        // if (onlineUsers.length === 0) {
        //   // console.log("initial online user setup", onlineUsers); 
        //   if (channel.presences) {
        //     for (var i = 0; i < channel.presences.length; i++) {
        //       if (user) { //guard statement
        //         // console.log("startup channel presence: ", channel.presences[i]);
        //         if (user.id.toString() !== channel.presences[i].user_id.toString()) {
        //           onlineUsers.push(channel.presences[i]);
        //         }
        //       }
        //     }
        //   }
        // }
        // setOnlineUsers(onlineUsers);
      }
    }
    if (socketConnected) {
      _joinChat(roomName);
      props.setJoinChat(false);
    }
  }, [props.joinChat, socketConnected])

  useEffect(() => {
    // Only set the socket handler if socket is available
    if (socket) {
      socket.onchannelpresence = async (presences) => {
    // Remove all users who left.
    if (presences.leaves) {
      // System messaging for user leaving
      const leaveMessages = presences.leaves.map((presence) => ({
        username: "System",
        content: {
          message: `${presence.username} has left the chat`
        },
        user_id: presence.user_id,
      }));
      if (leaveMessages.length > 0) {
        setMessages(prev => [...prev, ...leaveMessages]);
      }

      // Maintaining User Array when new user(s) leave
      let temp = [];
      // flag used as a check if a user in the presence leaves array matches a user in the current onlineUsers
      // (true - user id in onlineUsers is not present in presences leaves)
      let flag = true;

      temp = onlineUsers.filter((onlineUser) => {
        // console.log("User from onlineUsers filter", onlineUser);
        flag = true;
        for (var i = 0; i < presences.leaves.length; i++) {
          const presence = presences.leaves[i];
          // console.log("presence from leaves update loop: ", presence);
          if (onlineUser.user_id.toString() === presence.user_id.toString()) {
            // flag = false;
            return flag = false;
          }
        }
        return flag;
      })
      // console.log("temp post filter: ", temp);
      setOnlineUsers(temp); //Stores in useRef so the onlineUsers array previous data will persist on refresh
      // console.log("onlineUsers post leave filter", onlineUsersRef);

    }

    else if (presences.joins) {
      // System messaging for when a new user joins the lobby chatroom
      const joinMessages = presences.joins.map((presence) => ({
        username: "System",
        content: {
          message: `${presence.username} has joined the chat`
        },
        user_id: presence.user_id,
      }));
      if (joinMessages.length > 0) {
        setMessages(prev => [...prev, ...joinMessages]);
      }

      //Maintaining onlineUsers Array for new joined users
      // _setOnlineUsers(onlineUsersRef);
      let temp = [...onlineUsers];
      let isUserjoining = false;
      for (var i = 0; i < presences.joins.length; i++) {
        // Looping through new presences and adding them to current online users array if that user is not the current user
        // console.log(presences.joins[i]);
        // console.log("user id: ", user.id);
        const presence = presences.joins[i];
        if (user) {
          if (user.id.toString() !== presence.user_id.toString()) {
            temp.push(presence);
          }
          else {
            isUserjoining = true;
          }
        }
        else { //user is undefined on first render
          isUserjoining = true;
        }
      }
      if (!isUserjoining) { //only update if the user joining is not the current user (not the first render to avoid race condition with the joinChat useEffect)
        setOnlineUsers(temp);
      }
      // console.log("onlineUsers post joins push", onlineUsersRef);
    }
      };
    }
  }, [socket]); // Add dependency on socket

  useEffect(() => {
        //console.log("friendRequestPending: ", friendRequestPending);
    if(friendRequestPending){
      setShowNotify("visible");
    }
    if(boneReady){
      setShowNotify("visible");
    }
  }, [friendRequestPending, boneReady])

  useEffect(() => {
    setupInternalPhaserEventListeners();
  }, []);

  useEffect(() => {
    const leaveChat = async () => {
      if (socket && chatChannel) {
        if (props.showMatchAnnouncement && props.opCodeData != null) {
          //get user's information from nakama
          const account = await client.getAccount(session);
          const user = account.user;

          let newMatchStarted = {
            message: `${session.username} vs ${props.player2Data.username} Watch Now!`,
            wagerType: props.wagerType,
            match_id: props.opCodeData.match_id
          } 
          JSON.stringify(newMatchStarted)
          // console.log("player 2 data: ", props.player2Data)
          await socket.writeChatMessage(chatChannel.id, newMatchStarted);
        }
        await socket.leaveChat(chatChannel.id);
      }
    }
    if (props.leaveChat && socketConnected && chatChannel) {
      leaveChat();
      props.setLeaveChat(false);
    }
  }, [props.leaveChat && socketConnected && props.showMatchAnnouncement])

  useEffect(() => {
    // Only set the socket handler if socket is available
    if (socket) {
      socket.onchannelmessage = (message) => {
        if (user && message.sender_id && message.sender_id.toString() === user.id.toString()) setUserMessage("");
        setMessages(prev => [...prev, message]);
        setMessageCount(prev => prev + 1);
        playSound("newMessageSound");
      };
    }
  }, [socket]);

  const sendMessage = async () => {
    if (socket && chatChannel) {
      var data = { message: userMessage };
      JSON.stringify(data);
      await socket.writeChatMessage(chatChannel.id, data);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
      sendMessage();
    }
  };

  var scrollingElement = document.getElementById("message-logs");
  const handleNewMessage = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        var element = document.getElementById("message-logs");
        element.scrollTo(0, element.scrollHeight);
      }
    }
  }
  const observer = new MutationObserver(handleNewMessage);
  if (scrollingElement) observer.observe(scrollingElement, { childList: true })

  return (
    <>
      <div style={{ display: "inline-block", height: "0", margin: 0, padding: 0, zIndex:'5' }}>
          <a href="https://zoombies.world/auth/wallet-insights" title="Update avatar">
            <img src={pfpRingPanel} className="profile-ring" alt="" />
          <img src={props.profilePicture} className="profile-picture" alt="profile" />
         
          </a>
      </div>
      <a href="https://zoombies.world/auth/wallet-insights" title="Update avatar" style={{zIndex: 10, textDecoration: "none"}}>
      <h1 className="username"  style={{ color : "#00d1ff", textDecoration : "inherit" }}>
          {props.user &&
              `${props.user.username.substring(0, 15)}`
          }
      </h1>
      </a>
      <img src="/bonez/images/notify.png" title="Pending notifications" className="notify-icon-auth" alt="Notification" style={{visibility : showNotify}} />
      <div id="message-logs">
        {messagesRef.current.map((message, index) => {
          return (
            message.content.message !== "" && (
              <div key={index}>
                <Message
                  content={message.content.message}
                  count={index}
                  time={message.create_time}
                  username={message.username}
                  sender_id={message.sender_id}
                  self={user && user.id === message.sender_id}  // used to check if message was sent by current user to determine styling
                  userAvatars={userAvatars}
                  wagerType={message.content.wagerType}
                  client={client}
                  session={session}
                  joinMatch={joinMatch}
                  availableMatchesQuery={props.availableMatchesQuery}
                  spectating={props.spectating}
                  player2Data={player2Data}
                  match_id={message.content.match_id}
                />
              </div>)
          )
        })}
        <div id="anchor"></div>
      </div>
      <div className="message-form" onKeyDown={handleKeyPress}>
        <input
          type='text'
          value={userMessage}
          onChange={(e) => { setUserMessage(e.target.value) }}
          className="message-input-box message-form-text"
          placeholder="Send Message"
          style={{ width: '100%', color: "#000000" }}
          maxLength="50"
        />
        <button 
          onClick={(e) => {
            playSound("clickSound");
            sendMessage();
          }}
          className="send-button btn btn-primary"
        >
          <h1 className="message-form-text" style={{ color: "#FFFFFF" }}>Send</h1>
        </button>
      </div>
      <audio id="newMessageSound" className="sound-fx" hidden>
        <source src="/bonez/sounds/new-message.mp3" type="audio/mp3"/>
      </audio>
    </>
  )
}

export default ChatRoom